import React, { useState, useContext } from 'react';
import * as dfd from "danfojs";
import { 
  Drawer, Button, Dialog, DialogTitle, 
  DialogContent, DialogActions, TextField, Input, Tooltip,
  Select, MenuItem, FormControl, InputLabel, Radio, RadioGroup, FormControlLabel
} from '@mui/material';
import { navbarHeight } from '../../config';
import './FactorViewDrawer.css';
import FactorViewer from './FactorViewer'; 

import { LayerContext } from '../LayerContext';
import { CatalogContext } from '../CatalogContext';
import { extractTitleFromUrl } from "../../common/layer/util";

const FactorViewDrawer = ({ isOpen, onClose }) => {
  
  const { layers } = useContext(LayerContext);
  const { catalog, setCatalog } = useContext(CatalogContext);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [inputType, setInputType] = useState('URL');
  const [dataPath, setDataPath] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [dataFrame, setDataFrame] = useState(null);
  const [linkedLayer, setLinkedLayer] = useState('');
  const [selectedOption, setSelectedOption] = useState('');

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  
  const handleConfirm = () => {
    if (inputType === 'URL') {
      dfd.readCSV(dataPath)
      .then(cdf => {
        const log = cdf["pval"].add(Number.MIN_VALUE).apply((x) => { return - Math.log10(x) });
        cdf.addColumn("-log(pval)", log, { inplace: true });
        setDataFrame(cdf);
      });
    } else if (inputType === 'FILE' && selectedFile) {
      dfd.readCSV(selectedFile).then(cdf => {
        const log = cdf["pval"].add(Number.MIN_VALUE).apply((x) => { return - Math.log10(x) });
        cdf.addColumn("-log(pval)", log, { inplace: true });
        setDataFrame(cdf);
      });
    }
    handleCloseDialog();
  };

  const displayPath = () => {
    if (inputType === 'URL') {
      return dataPath;
    } else if (inputType === 'FILE' && selectedFile) {
      return selectedFile.name; // Assuming selectedFile is a File object
    }
    return '';
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value); // Step 4
    setDataPath(event.target.value); // Step 5
  };

  return (
    <>
    <Drawer
      anchor="right" open={isOpen}
      onClose={onClose} variant="persistent"
      PaperProps={{ style: { width: '400px', top:  navbarHeight } }}
      className="drawer"
    >
      <div className='top-container'>
        <Button color="success" variant="outlined" onClick={handleOpenDialog}>Load DE</Button>
        <Tooltip title={displayPath()} placement="bottom-start">
          <div className='path-display'>{displayPath().replace(".bulk_chisq.tsv", "")}</div>
        </Tooltip>
      </div>
      {/* <div className='top-container'> */}
      {/*   <FormControl fullWidth variant="standard" style={{ marginBottom: '24px' }}> */}
      {/*     <InputLabel style={{ color:'#555' }}>Link to a Layer</InputLabel> */}
      {/*     <Select */}
      {/*       value={linkedLayer} */}
      {/*       size='small' */}
      {/*       onChange={(event) => setLinkedLayer(event.target.value)} */}
      {/*       label="Link to a Layer" */}
      {/*     > */}
      {/*       {layers.filter(layer => layer.assetType === 'fic' || layer.assetType === 'hexa').map((layer) => ( */}
      {/*         <MenuItem key={layer.id} value={layer.id}>{layer.assetType} - {layer.title}</MenuItem> */}
      {/*       ))} */}
      {/*     </Select> */}
      {/*   </FormControl> */}
      {/* </div> */}
      <FactorViewer df={dataFrame} />
    </Drawer>
    <Dialog open={dialogOpen} onClose={handleCloseDialog}>
      <DialogTitle >Load DE</DialogTitle>
      <DialogContent>
       <div style={{ maxHeight: '300px', overflowY: 'auto', margin: '10px' }}>
        <RadioGroup
          style={{ flexDirection: 'column' }}
          aria-label="DE Options"
          name="DEOptions"
          value={selectedOption} 
          onChange={handleOptionChange} 
        >
          {Array.isArray(catalog?.assets?.factor?.DE) && 
            catalog.assets.factor.DE.map((option, index) => ( 
            <FormControlLabel
              key={index}
              value={option}
              control={<Radio />}
              label={extractTitleFromUrl(option)}
              className="radioDELabel"
              style={{
                backgroundColor: getBackgroundColor(index), // Alternate background color
              }}
            />
          ))}
        </RadioGroup>
      </div>
        {inputType === 'URL' ? (
          <TextField
            fullWidth
            label="URL"
            value={dataPath}
            onChange={e => setDataPath(e.target.value)}
          />
        ) : (
          <Input
            type="file"
            onChange={e => setSelectedFile(e.target.files[0])}
            fullWidth
          />
        )}
        <Button onClick={() => setInputType('URL')}>Use URL</Button>
        <Button onClick={() => setInputType('FILE')}>Upload File</Button>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog} color="primary">Cancel</Button>
        <Button onClick={handleConfirm} color="primary">Confirm</Button>
      </DialogActions>
    </Dialog>
    </>
  );
}

function getBackgroundColor(index) {
  return index % 2 === 0 ? '#222' : '#444'; // Example colors
}

export default FactorViewDrawer;
